import React, { useState, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as actions from "../../../../store/actions";
import { Typography, TextField, FormControl, Dialog, Divider, Button, } from '@mui/material';
import {
  FormStyled, DivSubmitButtons, DivFormTitle
} from '../../../Admin/Forms/styles';

import Spinner from '../../../../components/Spinner/index';

interface IProps {
  onClose: CallableFunction;
  open: boolean;
}

const ModalEquipmentsRegistrationLimit = (props: IProps) => {
  const dispatch = useDispatch();

  const selectedTenant = useSelector((state: any) => state.tenants.tenant);
  const loadingTenant = useSelector((state: any) => state.tenants.loadingTenant);

  const [maxEquipments, setMaxEquipments] = useState(0);
  const [tolerance, setTolerance] = useState(0);

  const [maxEquipmentsError, setMaxEquipmentsError] = useState(false);



 useEffect(() => {
    if (props.open) {
      const equipmentsRegistrationLimit = selectedTenant.equipmentsRegistrationLimit

      setMaxEquipments(equipmentsRegistrationLimit?.maxEquipments || 0)
      setTolerance(equipmentsRegistrationLimit?.tolerance || 0)
    } else {
      setMaxEquipments(0);
      setTolerance(0);
    }
  }, [selectedTenant, props.open])

  const fetchTenant = useCallback(() => dispatch(actions.fetchTenantsByIdSuperadmin(selectedTenant._id)), [selectedTenant._id]);

  interface IBody {
    maxEquipments: number;
    tolerance: number;
  }

  const updateEquipmentsRegistrationLimit = (body: IBody) => dispatch(actions.tenantUpdateEquipmentsRegistrationLimit(selectedTenant._id, body)) as unknown as Promise<string>;

  const handleSubmit = async () => {

    let hasError = false;

    if (maxEquipments === 0) {
      hasError = true;
      setMaxEquipmentsError(true);
    }

    if (hasError) return

    const body = {
      maxEquipments,
      tolerance
    };

    updateEquipmentsRegistrationLimit(body).then(result => {
      if (result === 'success') {
        props.onClose();
        fetchTenant();
      }
    });
  }

  return (
    <Dialog
      maxWidth='sm'
      fullWidth
      scroll='body'
      open={props.open}
      onClose={() => props.onClose()}
    >
      <FormStyled onSubmit={handleSubmit} style={{ ...styles.opacityContainer, opacity: loadingTenant ? '0.3' : '1' }}>
        {loadingTenant && <Spinner overlay />}
        <DivFormTitle>
          <Typography variant='h6'>Alterar Plano</Typography>
        </DivFormTitle>
        <Divider />
        <FormControl variant="standard" fullWidth margin='normal' required>
          <TextField
            variant="standard"
            label='Número máximo de equipamentos'
            name='maxEquipments'
            onChange={event => { setMaxEquipmentsError(false); setMaxEquipments(parseInt(event.target.value) > -1 ? parseInt(event.target.value) : 0); }}
            value={maxEquipments.toString()}
            margin='normal'
            error={maxEquipmentsError}
            helperText="O número de equipamentos deve ser positivo"
            type="number"
          />
          <TextField
            variant="standard"
            label='Limite de excedente (%)'
            name='tolerance'
            onChange={event => { setTolerance(parseInt(event.target.value) > -1 ? parseInt(event.target.value) : 0); }}
            value={tolerance.toString()}
            margin='normal'
            type="number"
            helperText="Após aplicar a porcentagem de tolerância, caso o adicional de equipamntos for um número fracionado, o mesmo será arredondado para o número inteiro maior e mais próximo do valor"
          />
        </FormControl>
        <DivSubmitButtons>
          <Button sx={{color: '#D32F2F', marginRight: '10px' }} onClick={() => props.onClose()}>Cancelar</Button>
          <Button sx={{color: '#fff', background: '#4CAF50' }} onClick={() => handleSubmit()}>Alterar</Button>
        </DivSubmitButtons>
      </FormStyled>
    </Dialog>
  );
}

export default ModalEquipmentsRegistrationLimit;

const styles = {
  container: {
    padding: '10px',
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  print: {
    marginRight: 5,
  },
  contentContainer: {
    margin: '30px 0',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  opacityContainer: {
    position: 'relative'
  },
  fileError: {
    color: '#f44336'
  },
  question: {
    marginTop: 20,
  },
  sectionTitleContainer: {
    display: 'flex',
    marginTop: 20,
  },
  avatarContainer: {
    display: 'flex',
    padding: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatar: {
    width: 150,
    height: 150,
    marginTop: 20,
  },
  avatarButton: {
    margin: 5,
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  imageInput: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: 10,
  },
  buttonEditImage: {
    // margin: '-58px 0 0 -146px',
    margin: '10px 0',
  }
}
